import { useLiveQuery } from 'dexie-react-hooks';
import { addDays, type DailyMilkUsageRecord, type MilkRecordRecord, type SaleRecord } from '@dairy/shared';
import { db } from '@/db/db';

export function useMilkRecords(from: string, to: string): MilkRecordRecord[] | undefined {
  return useLiveQuery(() => db.milkRecords.where('date').between(from, to, true, true).toArray(), [from, to]);
}

export function useUsage(from: string, to: string): DailyMilkUsageRecord[] | undefined {
  return useLiveQuery(() => db.dailyMilkUsage.where('date').between(from, to, true, true).toArray(), [from, to]);
}

export function useMilkSales(from: string, to: string): SaleRecord[] | undefined {
  return useLiveQuery(
    () => db.sales.where('date').between(from, to, true, true).filter((s) => s.type === 'MILK').toArray(),
    [from, to],
  );
}

/** Records of the last `days` days ending `date` (for averages and alerts). */
export function useRecentMilk(date: string, days = 8): MilkRecordRecord[] | undefined {
  return useMilkRecords(addDays(date, -days), date);
}
